import { CSSObject, Theme } from '@mui/material'

import { ChipColor } from 'components/Chips/StatusChip/types'
import { AbTest } from 'features/ab-tests/types/abTest'

export const chipColors: ChipColor<AbTest['status']> = (
  theme: Theme,
  status: AbTest['status'],
): CSSObject['backgroundColor'] => {
  switch (status) {
    case 'active':
      return theme.palette.success.main
    case 'completed':
      return theme.palette.grey[500]
    case 'draft':
      return theme.palette.warning.main
  }
}
